import { bootstrap } from "@idse/core";
bootstrap().catch(() => {
    console.error("App bootstrap failed: ");
  });



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/index.tsx